import { createClient } from "@supabase/supabase-js";

const rawUrl = (process.env.REACT_APP_SUPABASE_URL || "").trim().replace(/\/+$/, "");
const url = /^https?:\/\//.test(rawUrl) ? rawUrl : `https://${rawUrl}`;
const anonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || "").trim().replace(/^"|"$/g, "");

export const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true },
  realtime: { params: { eventsPerSecond: 10 } },
});
